<template>
  <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9.5" cy="10" r="9.5" fill="#027D9C" />
    <line x1="9.80371" y1="4.60278" x2="9.80371" y2="15.4528" stroke="white" stroke-width="1.5"
      stroke-linecap="round" />
    <line x1="14.9531" y1="10.3027" x2="4.10312" y2="10.3027" stroke="white" stroke-width="1.5"
      stroke-linecap="round" />
  </svg>
</template>